const isImageLoaded = ($img) => {
	if (!$img.complete) return false;
	if (typeof $img.naturalWidth !== 'undefined' && $img.naturalWidth === 0) return false;
	return true;
};

const imageSizeTranslation = (columnWidth = '', imageObj, seperator = '-', lazyLoad, limitLower = false, imageWidth = false) => {
	const returnObj = {};
	const useLazy = lazyLoad !== false;
	let width = 1;
	columnWidth = columnWidth.toString();
	if (!imageObj || Object.keys(imageObj).length === 0) return {};
	if (imageObj.src) imageObj.url = imageObj.src;
	if (/\.(svg|gif)$/.test(imageObj.url)) columnWidth = 'noResize';
	const imageName = imageObj.url.slice(0, imageObj.url.lastIndexOf('.'));
	const imageExt = imageObj.url.slice(imageObj.url.lastIndexOf('.'));

	if (imageWidth !== false) {
		returnObj[useLazy ? 'data-src' : 'src'] = `${imageName}${seperator}${imageWidth}x${imageExt}`;
		returnObj.alt = imageObj.alt;
		returnObj.width = imageWidth;
		if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * imageWidth);
		if (useLazy) returnObj.className = 'js-lazyLoad';
		return returnObj;
	}

	switch (columnWidth) {
		case 'full':
			width = 2000;
			returnObj[useLazy ? 'data-src' : 'src'] = `${imageName}${seperator}2600x${imageExt}`;
			returnObj[useLazy ? 'data-srcset' : 'srcSet'] = `${imageName}${seperator}2600x${imageExt} 2000w, ${imageName}${seperator}2400x${imageExt} 1600w, ${imageName}${seperator}1800x${imageExt} 1200w${(limitLower ? '' : `, ${imageName}${seperator}1200x${imageExt} 800w, ${imageName}${seperator}600x${imageExt} 400w`)}`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 400px) 400px, (max-width: 800px) 800px, ')}(max-width: 1200px) 1200px, (max-width: 1600px) 1600px, 2000px`;
			break;
		case '12':
		case '11':
		case '10':
			width = 1600;
			returnObj[useLazy ? 'data-src' : 'src'] = `${imageName}${seperator}2400x${imageExt}`;
			returnObj[useLazy ? 'data-srcset' : 'srcSet'] = `${imageName}${seperator}2400x${imageExt} 1600w, ${imageName}${seperator}1800x${imageExt} 1200w${(limitLower ? '' : `, ${imageName}${seperator}1200x${imageExt} 800w, ${imageName}${seperator}600x${imageExt} 400w`)}`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 400px) 400px, (max-width: 800px) 800px, ')}(max-width: 1200px) 1200px, 1600px`;
			break;
		case '9':
		case '8':
		case '7':
			width = 1200;
			returnObj[useLazy ? 'data-src' : 'src'] = `${imageName}${seperator}1800x${imageExt}`;
			returnObj[useLazy ? 'data-srcset' : 'srcSet'] = `${imageName}${seperator}1800x${imageExt} 1200w${(limitLower ? '' : `, ${imageName}${seperator}1200x${imageExt} 800w, ${imageName}${seperator}600x${imageExt} 400w`)}`;
			returnObj.sizes = `${(limitLower ? '' : '(max-width: 400px) 400px, (max-width: 800px) 800px, ')}1200px`;
			break;
		case '6':
		case '5':
		case '4':
			width = 800;
			returnObj[useLazy ? 'data-src' : 'src'] = `${imageName}${seperator}1200x${imageExt}`;
			returnObj[useLazy ? 'data-srcset' : 'srcSet'] = `${imageName}${seperator}1200x${imageExt} 800w, ${imageName}${seperator}600x${imageExt} 400w`;
			returnObj.sizes = '(max-width: 400px) 400px, 800px';
			break;
		case '3':
		case '2':
		case '1':
			width = 400;
			returnObj[useLazy ? 'data-src' : 'src'] = `${imageName}${seperator}600x${imageExt}`;
			break;
		default:
			width = imageObj.width;
			returnObj[useLazy ? 'data-src' : 'src'] = imageObj.url;
	}
	returnObj.alt = imageObj.alt;
	returnObj.width = width;
	if (imageObj.height) returnObj.height = Math.round((imageObj.height / imageObj.width) * width);
	else if (seperator === '_') returnObj.height = (width / 4) * 5;
	if (useLazy) returnObj.className = 'js-lazyLoad';

	return returnObj;
};

export { isImageLoaded, imageSizeTranslation };
